import React, { Component } from 'react';
import { Navbar, NavbarBrand } from 'reactstrap';
import Menu from './MenuComponent';
import DishDetail from './DishdetailComponent';
import Home from './HomeComponent';
import Header from './HeaderComponent';
import Footer from './FooterComponent';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'
import { DISHES } from '../shared/books';
import Contact from './ContactComponent';
import Quiz from './QuizComponent';
import Play from './PlayComponent';
import Engine from './EngineComponent';
import Simuls from './SimulsComponent';
import SimulDetail from './SimuldetailComponent';
import Combos from './CombosComponent';
import Fischerteaches from './FischerteachesComponent';
import Reviews from './ReviewsComponent';
import ReviewDetail from './ReviewdetailComponent';
import ComboDetail from './CombosdetailComponent';
import FischerteachDetail from './FischerteachesdetailComponent';
import Updates from './UpdatesComponent';
import UpdateDetail from './UpdatedetailComponent';
import { COMMENTS } from '../shared/comments';
//import { PROMOTIONS } from '../shared/promotions';
import { REVIEWS } from '../shared/reviews';
import { UPDATES } from '../shared/updates';
import { LEADERS } from '../shared/leaders';
import { SIMULS } from '../shared/simuls';
import { COMBOS } from '../shared/combos';
import { FISCHERTEACHES } from '../shared/fischerteaches';
import About from './AboutComponent';
import { connect } from 'react-redux';
import { addComment, fetchDishes } from '../redux/ActionCreators';
import { actions } from 'react-redux-form';

const mapStateToProps = state => {
  return {
    dishes: state.dishes,
    comments: state.comments,
    promotions: state.promotions,
    leaders: state.leaders,
    reviews: state.reviews,
    updates: state.updates,
    simuls: state.simuls,
    combos: state.combos,
    fischerteaches: state.fischerteaches,
    comboResults: state.comboResults
  }
}

const mapDispatchToProps = dispatch => ({
    addComment: (dishId, rating, author, comment) => dispatch(addComment(dishId, rating, author, comment)),
    fetchDishes: () => { dispatch(fetchDishes())},
    resetFeedbackForm: () => { dispatch(actions.reset('feedback'))},
    //updateNumberRight: (numberRight) => { dispatch(updateNumberRight(numberRight))}
  });

class Main extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchDishes();
  }

  render() {

    const HomePage = () => {
      return(
          <Home
              dish={this.props.dishes.dishes.filter((dish) => dish.featured)[0]}
              dishesLoading={this.props.dishes.isLoading}
              dishesErrMess={this.props.dishes.errMess}
              review={this.props.reviews.filter((review) => review.featured)[0]}
              leader={this.props.leaders.filter((leader) => leader.featured)[0]}
          />
      );
    }

    const DishWithId = ({match}) => {
      return(
          <DishDetail dish={this.props.dishes.dishes.filter((dish) => dish.id === parseInt(match.params.dishId,10))[0]}
            isLoading={this.props.dishes.isLoading}
            errMess={this.props.dishes.errMess}
            comments={this.props.comments.filter((comment) => comment.dishId === parseInt(match.params.dishId,10))}
            addComment={this.props.addComment}
          />
      );
    };

    const ReviewWithId = ({match}) => {
      return(
          <ReviewDetail review={this.props.reviews.filter((review) => review.id === parseInt(match.params.reviewId,10))[0]}
            max={Math.max(...this.props.reviews.map(review => review.id))}
            min={Math.min(...this.props.reviews.map(review => review.id))}
            isLoading={this.props.reviews.isLoading}
            errMess={this.props.reviews.errMess}
          />
      );
    };

    const UpdateWithId = ({match}) => {
      return(
          <UpdateDetail update={this.props.updates.filter((update) => update.id === parseInt(match.params.updateId,10))[0]}
            max={Math.max(...this.props.updates.map(update => update.id))}
            min={Math.min(...this.props.updates.map(update => update.id))}
            isLoading={this.props.updates.isLoading}
            errMess={this.props.updates.errMess}
          />
      );
    };

    const SimulWithId = ({match}) => {
      return(
          <SimulDetail simul={this.props.simuls.filter((simul) => simul.id === parseInt(match.params.simulId,10))[0]}
            max={Math.max(...this.props.simuls.map(simul => simul.id))}
            min={Math.min(...this.props.simuls.map(simul => simul.id))}
            isLoading={this.props.simuls.isLoading}
            errMess={this.props.simuls.errMess}
          />
        );
      };


      const ComboWithId = ({match}) => {
        return(
            <ComboDetail combo={this.props.combos.filter((combo) => combo.id === parseInt(match.params.comboId,10))[0]}
              max={Math.max(...this.props.combos.map(combo => combo.id))}
              min={Math.min(...this.props.combos.map(combo => combo.id))}
              isLoading={this.props.combos.isLoading}
              errMess={this.props.combos.errMess}
              //numberRight={this.props.comboResults.numberRight}
              //numberWrong={this.props.comboResults.numberWrong}
              //moveIndex={this.props.comboResults.moveIndex}
              //updateNumberRight={this.props.updateNumberRight}
            />
        );
    };

    const FischerteachWithId = ({match}) => {
      return(
          <FischerteachDetail fischerteach={this.props.fischerteaches.filter((fischerteach) => fischerteach.id === parseInt(match.params.fischerteachId,10))[0]}
            max={Math.max(...this.props.fischerteaches.map(fischerteach => fischerteach.id))}
            min={Math.min(...this.props.fischerteaches.map(fischerteach => fischerteach.id))}
            isLoading={this.props.fischerteaches.isLoading}
            errMess={this.props.fischerteaches.errMess}
          />
      );
    };

    return (
      <div>
        <Header />
        <div>
          <Switch>
              <Route path='/home' component={HomePage} />
              <Route exact path='/aboutus' component={() => <About leaders={this.props.leaders} />} />} />
              <Route exact path='/menu' component={() => <Menu dishes={this.props.dishes} />} />
              <Route path='/menu/:dishId' component={DishWithId} />
              <Route exact path='/contactus' component={() => <Contact resetFeedbackForm={this.props.resetFeedbackForm} />} />
              <Route exact path='/quiz' component={() => <Quiz />} />
              <Route exact path='/play' component={() => <Play />} />
              <Route exact path='/engine' component={() => <Engine />} />
              <Route exact path='/reviews' component={() => <Reviews reviews={this.props.reviews} />} />
              <Route path='/reviews/:reviewId' component={ReviewWithId} />
              <Route exact path='/updates' component={() => <Updates updates={this.props.updates} />} />
              <Route path='/updates/:updateId' component={UpdateWithId} />
              <Route exact path='/simuls' component={() => <Simuls simuls={this.props.simuls}/>} />
              <Route path='/simuls/:simulId' component={SimulWithId} />
              <Route exact path='/combos' component={() => <Combos combos={this.props.combos}/>} />
              <Route path='/combos/:comboId' component={ComboWithId} />
              <Route exact path='/fischerteaches' component={() => <Fischerteaches fischerteaches={this.props.fischerteaches}/>} />
              <Route path='/fischerteaches/:fischerteachId' component={FischerteachWithId} />
              <Route component={HomePage} />
              <Redirect to="/home" />
          </Switch>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));
